var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.getCashier || _vm.getType==4 || _vm.getTerminal)?_c('Toolbar'):_vm._e(),(!this.checkIsMobile() && (this.getCurrentPage == 'live_detail'  || this.getCurrentPage == 'live_list'))?_c('LiveMatchTrackerAmerican'):_vm._e(),_c('BetInAcceptance')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }